module.exports = __webpack_public_path__ + "static/media/dashboard-scape-card-4-icon.64307c64.svg";